export default `
<div>
  <div class="grid w890">
    <h2>Following</h2>
    <div class="user-list">
      <user-list-item user="user"  ng-repeat="user in following.feedItems"  ></user-list-item>
    </div>
    <ut-load-more (load-more)="following.loadMore()" [is-loading]="following.isLoading" [is-last-page]="following.isLastPage"></ut-load-more>
  </div>
</div>
`;
